// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + ({"3976":"npm.babel","4500":"npm.chartjs-adapter-date-fns","6732":"npm.date-fns","8836":"npm.kurkle","9095":"npm.chart.js"}[chunkId] || chunkId) + ".esm.js";
};